import * as React from "react";
import { AutoGrowTextarea } from "../detail/AutoGrowTextarea";
import "./vorgangV4.css";

/**
 * Der Untertitel des VORGANGS — `vorgang.beschreibung`.
 *
 * Er steht an zwei verschiedenen Stellen, je nachdem, ob es To-dos gibt
 * (PO 13.09.2026, Mockup Zustand 1/2):
 *
 *  · OHNE To-dos im Kopf, unter der Meta-Zeile ({@link VorgangKopfV4}).
 *  · MIT To-dos unter dem Betreff des ERSTEN To-dos, über TWV und Frist —
 *    dort, wo der Vorgang jetzt lebt (er IST To-do 1).
 *
 * Deshalb ein eigener Baustein statt zweier Abschriften: es bleibt EIN Feld
 * mit EINEM Speicherpfad, gerendert an zwei Orten. In die `TodoKarteV4` gehört
 * er ausdrücklich nicht — die Karte weiß nichts vom Vorgang und speichert über
 * `vorgangService.updateTodo`; sie nimmt ihn als fertigen Knoten entgegen
 * (`vorgangsZeile`).
 */
type Props = {
    /** Der Entwurf im Feld — gehalten von der Seite. */
    wert: string;
    /** Was zuletzt gespeichert wurde; nur bei Abweichung wird geschrieben. */
    gespeichert: string;
    canEdit: boolean;
    onAendern: (v: string) => void;
    onSpeichern: (v: string) => void;
};

export const VorgangUntertitelV4: React.FC<Props> = ({
    wert,
    gespeichert,
    canEdit,
    onAendern,
    onSpeichern,
}) => (
    <AutoGrowTextarea
        className="vg4-untertitel"
        minRows={1}
        readOnly={!canEdit}
        placeholder="Untertitel oder kurze Beschreibung…"
        value={wert}
        onChange={onAendern}
        onBlurSave={(v) => {
            const t = v.trim();
            if (t !== gespeichert) onSpeichern(t);
        }}
    />
);
